<template>
  <a-modal
    title="新建"
    :width="1080"
    :visible="visible"
    :confirmLoading="loading"
    @ok="() => { $emit('ok') }"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" v-bind="formLayout">
        <a-row :gutter="[16,16]">
          <a-col :span="24">
            <a-form-item label="电表组">
              <a-select
                option-label-prop="tt"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                show-search
                allow-clear
                v-decorator="[
                  'group_id',
                  {
                    rules: [
                      { required: true, message: '' },
                    ],
                  },
                ]"
                placeholder="请输入电表组编号"
                :default-active-first-option="false"
                @search="groupSearch"
                @change="handleGroupChange"
              >
                <a-select-option v-for="d in groupData" :key="d.id" :tt="d.number">
                  {{ d.number }} ({{ d.name }})
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="批次">
              <a-input v-decorator="['batch', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" />
            </a-form-item>
            <a-form-item label="价格">
              <a-input-number v-decorator="['price', {rules: [{required: false, message: '必填项，请填写信息'}]}]" :precision="4"/>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
const { group_list } = require('@/api/electricity-meter-group')
export default {
  components: {},
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      }
    }
    return {
      color: '#3f3f3f',
      form: this.$form.createForm(this),
      groupData: [],
      groupAllData: []
    }
  },
  created () {
    this.groupList(undefined)
  },
  methods: {
    groupList (obj) {
      group_list(obj)
        .then(res => {
          this.groupData = res.data.entries
          if (obj === undefined) {
            this.groupAllData = this.groupData
          }
        })
    },
    handleGroupChange (value) {
      console.log(value)
      if (value === undefined) {
        this.groupData = this.groupAllData
      }
    },
    groupSearch (value) {
      console.log(value)
      this.groupList({ number: value })
    }
  }
}
</script>
